import {
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { authInterceptor } from './app/auth.interceptor';

/**
 * Deliberately much thinner than the customer app's bootstrap.
 *
 * No NgRx (four screens of mostly server state — `httpResource` already holds
 * it), no ngx-translate (staff-only, English), no Sentry, no Material. Every
 * one of those is a real cost in bundle size and in things a future maintainer
 * has to learn, and none earns its place in an internal tool this size. If the
 * backoffice ever grows to need them they can be added; starting with them
 * guarantees they are never removed.
 */
bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor]))
  ]
}).catch((err) => console.error(err));
